module.exports = __webpack_public_path__ + "img/map-marker-outline.0222c508.svg";